"use client";
import { useEffect, useState } from "react";
import LearnMoreIcon from "@/icons/learnMore.svg";

export default function MoveToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [buttonPosition, setButtonPosition] = useState('top');

  const handleScroll = () => {
    if (window.scrollY  > 400) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }

    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    if (scrollY + windowHeight >= documentHeight) {
      setButtonPosition('bottom');
    } else {
      setButtonPosition('middle');
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);



  return (
    <div id="btnScrollToTop" className={`fixed bottom-[${buttonPosition}vh] ${buttonPosition === "bottom" ? "tall:bottom-128 bottom-100" : "bottom-8 opacity-60 hover:opacity-100"}  right-8 z-200 transition-all overflow-visible lg:block hidden ${isVisible ? "visible" : "invisible"}`}>
      <button
        onClick={scrollToTop}
        className={`xl:w-16 xl:h-16 lg:w-12 lg:h-12 text-lg shadow-[0_10px_30px_-7px_var(--secondary-800)] hover:shadow-[0_10px_30px_-1px_var(--secondary-800)] whitespace-nowrap text-white bg-(image:--primary-gradient) rounded-full flex items-center justify-center cursor-pointer`}
      >
        <LearnMoreIcon className="w-[0.825rem] absolute -rotate-90 left-2/4 top-2/4 -translate-1/2" />
      </button>
    </div>
  );
}
